import React from "react"

import HomePage from "../components/HomePage"
import Header from "../components/Header"
import {Helmet} from "react-helmet";

import { library } from "@fortawesome/fontawesome-svg-core"
import { fab } from "@fortawesome/free-brands-svg-icons"
import { fas } from "@fortawesome/free-solid-svg-icons"

import "../styles.scss"

export default function Home() {
  library.add(fab, fas)
  return (
    <>
      {/* <Header /> */}
      <Helmet>
        <meta charSet="utf-8" />
        <title>Pranay Jain</title>
      </Helmet>
      <HomePage />
    </>
  )
}
